<div style="background-color: white;">
	<div class="modal-header">
		<button (click)="exit()" aria-label="Close" class="close" type="button">
		</button>
	</div>
	<div class="modal-body">
		<form class="form" [formGroup]="form">
			<app-form-input *ngIf="optionsSelect.length > 0" [parentForm]="form"
				[label]="motifModificationMessages.input | translate" [type]="'select'" [rule]="'required'"
				[options]="optionsSelect" [name]="'motif'"></app-form-input>
		</form>
	</div>
	<div class="modal-footer">
		<button (click)="valider()" class="btn btn-primary mr-1" type="button">Ok</button>
	</div>
</div>